import axios from "../axiosInstance";

const WishlistAPI = {
  dashboard: () => axios.get("wishlists"),
  getDetails: (id, query) => axios.get(`wishlists/${id}`, { params: query }),
};

export default WishlistAPI;
